<script>
import ShareRecordStarted from './share-record-started.vue'
import ShareRecordRecipientInfo from './share-record-recipient-info.vue'
import ShareRecordConfirmEmail from './share-record-confirm-email.vue'
import ShareRecordEndScreen from './share-record-end-screen.vue'
import ShareRecordQRScreen from './share-record-qr-screen.vue'

export default {
  components: {
    ShareRecordStarted,
    ShareRecordRecipientInfo,
    ShareRecordConfirmEmail,
    ShareRecordEndScreen,
    ShareRecordQRScreen,
  },
  props: {
    group: {
      type: Number,
      default: 0,
    },

    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      shareRecordConfirm: 'tab1',
      recipientInfo: {},
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  watch: {
    shareRecordConfirm(newvalue) {
      return newvalue
    },
  },
  methods: {
    closeDialog() {
      this.$emit('update:dialog', false)
      setTimeout(() => {
        this.selected = null
        this.shareRecordConfirm = 'tab1'
      }, 500)
    },
    setRecipientInfo(info) {
      this.recipientInfo = info
    },
  },
}
</script>

<template>
  <v-container class="pa-0">
    <v-dialog
      :value="dialog"
      :fullscreen="mobile"
      persistent
      no-click-animation
      overlay-color="body"
      overlay-opacity="0.6"
      min-width="300px"
      max-width="450px"
      scrollable
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.VdialogClass"
    >
      <ShareRecordStarted
        v-if="shareRecordConfirm === 'tab1'"
        @getStarted="shareRecordConfirm = 'tab2'"
        @getStartedQR="shareRecordConfirm = 'tab5'"
        @closeDialog="closeDialog"
      ></ShareRecordStarted>
      <ShareRecordRecipientInfo
        v-if="shareRecordConfirm === 'tab2'"
        @closeDialog="closeDialog"
        @confirmInfo="shareRecordConfirm = 'tab3'"
        @backClick="shareRecordConfirm = 'tab1'"
        @recipientInfo="setRecipientInfo"
      ></ShareRecordRecipientInfo>
      <ShareRecordConfirmEmail
        v-if="shareRecordConfirm === 'tab3'"
        :recipient-info="recipientInfo"
        @closeDialog="closeDialog"
        @confirmEmail="shareRecordConfirm = 'tab4'"
        @backClick="shareRecordConfirm = 'tab2'"
      ></ShareRecordConfirmEmail>
      <ShareRecordEndScreen
        v-if="shareRecordConfirm === 'tab4'"
        :recipient-info="recipientInfo"
        @closeDialog="closeDialog"
        @endScreen="shareRecordConfirm === ''"
        @backClick="shareRecordConfirm = 'tab3'"
      ></ShareRecordEndScreen>
      <ShareRecordQRScreen
        v-if="shareRecordConfirm === 'tab5'"
        :recipient-info="recipientInfo"
        @closeDialog="closeDialog"
        @backClick="shareRecordConfirm = 'tab1'"
      ></ShareRecordQRScreen>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.fabButton {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
}

.fabButtonOffset {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
  transform: translateX(-300px);
}

.VdialogClass {
  max-height: 100%;
  border-radius: 4px !important;

  /* width */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    margin-top: 5px;
    margin-bottom: 5px;
    background: $color-theme-light-input;
    border-radius: 15px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $color-theme-light-line;
    border-radius: 15px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $color-theme-light-placehold;
  }

  &::-webkit-scrollbar-thumb:active {
    background: $color-theme-light-label;
  }
}

@media screen and (max-width: 960px) {
  .VdialogClass {
    height: 100%;
    max-height: 90% !important;
    max-height: 100% !important;
    padding-bottom: 2px;
    margin: 0;
    overflow-y: scroll !important;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none;
  }
}
</style>
